import React from 'react';
import LottieLoading from '@womcorp/wom-miwom-ui-kit/dist/components/LottieLoading';
import { ContainerStyled, Wrapper } from './styles/WomLogoAnimationStyled';

const WomLogoAnimation = () => {
  return (
    <Wrapper>
      <ContainerStyled>
        <LottieLoading />
      </ContainerStyled>
    </Wrapper>
  );
};

export default WomLogoAnimation;
